import React, { useEffect } from 'react'
import Input from '../../components/UI/Input'
import { IConfigPageProps } from './types'
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";

function Notification(props: IConfigPageProps) {
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'notification'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  
  return (
    <>
      <Input
        label="Time before business start content update (minutes)" 
        type="number" 
        value={props.config.UPDATE_CONTENT_BEFORE_START_MINUTES}
        onChange={(e: any) => props.setConfig(e.target.value, 'UPDATE_CONTENT_BEFORE_START_MINUTES')}
        disabled={!canEdit}
      />
      <Input
        label="Interval window to spread content update calls (minutes)" 
        type="number" 
        value={props.config.UPDATE_CONTENT_SPREAD_WINDOW_MINUTES}
        onChange={(e: any) => props.setConfig(e.target.value, 'UPDATE_CONTENT_SPREAD_WINDOW_MINUTES')}
        disabled={!canEdit}
      />
      <Input
        label="Interval window to spread activate device calls (minutes)" 
        type="number" 
        value={props.config.ACTIVATE_DEVICE_SPREAD_WINDOW_MINUTES}
        onChange={(e: any) => props.setConfig(e.target.value, 'ACTIVATE_DEVICE_SPREAD_WINDOW_MINUTES')}
        disabled={!canEdit}
      />
      <Input
        label="Time before business end to notify clients (minutes)" 
        type="number" 
        value={props.config.BD_NOTIFY_BEFORE_END_MINUTES}
        onChange={(e: any) => props.setConfig(e.target.value, 'BD_NOTIFY_BEFORE_END_MINUTES')}
        disabled={!canEdit}
      />
      <Input
        label="Time after business end to close sessions (minutes)" 
        type="number" 
        value={props.config.BD_CLOSE_SESSIONS_AFTER_END_MINUTES}
        onChange={(e: any) => props.setConfig(e.target.value, 'BD_CLOSE_SESSIONS_AFTER_END_MINUTES')}
        disabled={!canEdit}
      />
      <Input
        label="Time after business end to execute after-work data processing (minutes)"
        type="number" 
        value={props.config.BD_AFTER_WORK_PROCESSING_AFTER_END_MINUTES}
        onChange={(e: any) => props.setConfig(e.target.value, 'BD_AFTER_WORK_PROCESSING_AFTER_END_MINUTES')}
        disabled={!canEdit}
      />
    </>
  )
}

export default Notification